export enum FieldType {
    FIELD = 'field',
    BLOCK = 'block'
}